import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import {
  Box,
  Button,
  Container,
  Grid,
  Segment,
  SegmentContent,
  SegmentHeader,
  Typography,
} from '@eGroupTeam/material';
import { Activity } from 'types';
import { getSelectedOrg } from 'redux/modules/common';
import { SWRResponse } from 'swr';

export interface ActivitySettingsProps {
  activity: Activity;
  mutateActivity: SWRResponse<unknown, unknown>['mutate'];
}

const ActivitySettings: FC<ActivitySettingsProps> = ({
  activity,
  mutateActivity,
}) => {
  const selectedOrg = useSelector(getSelectedOrg);
  // 2026-01 policy: activity creation & surveys are free; face recognition is disabled.
  // This page used to enable paid add-on services. Keep the page but show an informational message
  // to avoid any dependency on service-products / trial-fee / MICEPoint.

  return (
    <>
      <Container>
        <Segment>
          <SegmentHeader>
            <Typography variant="h5" fontWeight={400}>
              活動設定
            </Typography>
            <Typography variant="body1">
              您可以設定您的活動相關功能。
            </Typography>
          </SegmentHeader>
          <SegmentContent>
            <Typography variant="h5" fontWeight={400}>
              服務狀態
            </Typography>
            <Box py={3}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography variant="body1">
                    目前「建立活動」與「問卷」為免費功能，無需扣點與儲值；「人臉辨識」已停用，無法啟用。
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </SegmentContent>
        </Segment>
      </Container>
    </>
  );
};

export default ActivitySettings;
